// extracted by css-extract-rspack-plugin
export default {"messageBodyContainer":"messageBodyContainer-kymQpK","readOnlyPlain":"readOnlyPlain-algdIQ","reviewAndPayCta":"reviewAndPayCta-C9UBXk"};